// src/components/RequestedCard.js
import React from 'react';
import { Link } from 'react-router';
import { GeneralButton } from '../../../../common/inputs';
import Connect from "../../../../../img/icons/FMB_icon6.svg";


const RequestedCard = ({ connectedAccSw, onConfirm, onCancel }) => (
  <>
    <div className="card text-center">
      <div className="card-body">
        <div className="d-flex align-items-start mb-3">
            <h6 className="fw-bold mb-0">Connect to {connectedAccSw}</h6>
        </div>
          <>
             <img
                height={"400px"}
                src={Connect}
                className=""
              />
            <div className="mb-3">
                <h6 className="h6 mb-1 text-danger">We couldn’t complete authentication.</h6>
                <p className="mb-0">This usually happens because of expired sign-in session, or network issue.</p>
            </div>
            <GeneralButton
                type="button"
                onClick={onCancel}
                className="btn btn-sm btn-outline-secondary"
                name="Start Over"
            />
            {connectedAccSw === 'Xero' && (
              <Link onClick={onConfirm}>
                <GeneralButton className="btn btn-sm btn-primary ml-3" name="Retry Connection" />
              </Link>
            )}
          </>
      </div>
    </div>    
  </>
);

export default RequestedCard;
